// style-it is CommonJS with an `__esModule`-style `default` export, which not every module
// loader unwraps (the dev-server dependency optimizer serves the raw exports object). Bare
// "style-it" imports are aliased here; the deep import below bypasses that alias...
import StyleModule from "style-it/dist/style-it.js";

const unwrapped: unknown = (StyleModule as { default?: unknown })?.default ?? StyleModule;

export default unwrapped as typeof import("style-it").default;
